import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

export const ExportButton = ({
  onExport,
  variant = 'outlined',
  sx,
}: {
  onExport: () => void;
  variant?: 'text' | 'outlined' | 'contained' | 'soft';
  sx?: SxProps<Theme>;
}) => {
  const { t } = useTranslation('common');
  return (
    <Button
      variant={variant}
      onClick={onExport}
      startIcon={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 16 16"
          fill="none"
          style={{ display: 'block' }}
        >
          <path
            d="M14 11V14H2V11H0V14C0 15.1 0.9 16 2 16H14C15.1 16 16 15.1 16 14V11H14ZM3 5L4.41 6.41L7 3.83V12H9V3.83L11.59 6.41L13 5L8 0L3 5Z"
            fill="currentColor"
          />
        </svg>
      }
      sx={{ width: 96, height: 30, minHeight: 30, mr: 0, ...sx }}
    >
      {t('actions.export')}
    </Button>
  );
};
